export function formatBytes(bytes: number): string {
    if (bytes === 0) return '0 KB';
    const k = 1024;
    if (bytes < k * k) {
        return `${(bytes / k).toFixed(2)} KB`;
    } else {
        return `${(bytes / (k * k)).toFixed(2)} MB`;
    }
}
